module.exports = __webpack_public_path__ + "static/test-fox-41ad3e82b26a45193a4a7a6020e1989a.png";